import React from 'react'
import styled from 'styled-components'
import Loader from '../map/Loader'

export interface INavigationButtons {
    previousTitle?: string
    nextTitle: string
    onPreviousClick: () => void
    onNextClick: () => void
    isLoading?: boolean
}

const NavigationButtons: React.FC<INavigationButtons> = ({
    previousTitle,
    nextTitle,
    onPreviousClick,
    onNextClick,
    isLoading
}) => {

    return (
        <NavigationButtonsContainer>
            {
                previousTitle && (
                    <NavButton 
                        onClick={onPreviousClick}
                        disabled={isLoading}
                    >
                        {previousTitle}
                    </NavButton>
                )
            }
            <NextButton 
                onClick={onNextClick}
                disabled={isLoading}
            >
                {!isLoading ? nextTitle : ''}
                {isLoading && (
                    <LoaderContainer>
                        <Loader/>
                    </LoaderContainer>
                )}
            </NextButton>
        </NavigationButtonsContainer>
    )
}

const NavigationButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;

    & > button:nth-child(2) {
        margin-left: 8px;
    }
`

const LoaderContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const NavButton = styled.button`
    align-items: center;
    border-radius: 4px;
    padding: 14px 0;
    flex: 1;
    flex-grow: 1;
    background-color: ${({ theme }) => theme.color.buttonGrey};
    font-size: ${({ theme }) => theme.size.small};
    font-family: ${({ theme }) => theme.font.semi};
    font-weight: ${({ theme }) => theme.weight.semi};
    color: ${({ theme }) => theme.color.black};
    cursor: pointer;
    margin-top: 14px;
`

const NextButton = styled(NavButton)`
    background-color: ${({ theme }) => theme.color.primary};
    color: ${({ theme }) => theme.color.secondary};
    position: relative;
`

export default NavigationButtons
